import { Alert, Form, Space, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo } from 'react'
import { ToolStorageSupportAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { STORAGE_SUPPORT_TOOL_NAME, TOOL_STORAGE_USAGE_SUPPORTS } from './SettingStatusConstant'

const ToolStorageSupport = ({ toolName, handleStorageSupportChange }) => {
    const apiToolName = STORAGE_SUPPORT_TOOL_NAME[toolName]
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    const fetchData = useCallback(async () => {
        try {
            const resData = await ToolStorageSupportAPI.getToolStorageSupportMapping(apiToolName).promise;
            const selectedValue = Object.keys(resData)
            form.setFieldsValue({ storageSupport: selectedValue })
            handleStorageSupportChange(selectedValue);
        } catch (err) {
            console.error(err)
        }
    }, [apiToolName, form, handleStorageSupportChange])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])


    const fields = useMemo(() => [{
        name: "storageSupport",
        label: <Typography.Text>Select usage type for {toolName} to not ingest findings.</Typography.Text>,
        placeholder: <Typography.Text>Select {toolName} usage type</Typography.Text>,
        type: FieldTypes.MULTI_SELECT,
        options: parseSelectOptions(TOOL_STORAGE_USAGE_SUPPORTS),
        colSpan: 16,
        props: {
            allowClear: true
        }
    }], [toolName])


    return (
        <Space direction="vertical" className="m-b-m">
            <Alert
                description={
                    <Form
                        form={form}
                        style={{ minWidth: 600 }}
                        layout="vertical"
                        onValuesChange={(values) => {
                            handleStorageSupportChange(values.storageSupport)
                        }}
                    >
                        {generateFormFields(fields)}
                    </Form>
                }
            />
        </Space>
    )
}

export default ToolStorageSupport

const parseSelectOptions = (options = {}) => {
    const selectOption = [];
    Object.keys(options).forEach(key => {
        selectOption.push({ label: options[key], value: key })
    })
    return selectOption;
}
